import { MinzeElement } from 'minze'

export interface LvcCircleCloseIcon {}

export class LvcCircleCloseIcon extends MinzeElement {
  html = () => `
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#1E007D"/>
    <path d="M26 26C23.8097 24.1584 21.7007 22.2194 19.6797 20.1902M19.6797 20.1902C17.716 18.2184 15.791 16.136 14 14M19.6797 20.1902C21.5369 17.9769 23.7392 16.1295 26 14M19.6797 20.1902C17.5455 22.4597 15.9817 23.7904 14 26" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
